var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 7,
    viewBox: "0 0 27 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.66406,
    cy: 3.67188,
    r: 2.5,
    stroke: "#255097"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6641,
    cy: 3.67188,
    r: 2.5,
    stroke: "#255097"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6641,
    cy: 3.67188,
    r: 2.5,
    stroke: "#255097"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimary);
export default __webpack_public_path__ + "static/media/primary.0dded5e917c1cf43b409b6e2d1d34bbd.svg";
export { ForwardRef as ReactComponent };